import {MuWidget} from "mu-widget/lib/MuWidget";
import {MuUIDs} from "mu-widget/lib/MuUIDs";

//todo: ikona
export class UiRadioList extends MuWidget {
	// @ts-ignore
	public htmlName: string;

	public selectedItem: UiRadioListItem| null = null;

	public setDisabled(disabled: boolean): void
	{
		for(const k in this.items) this.items[k].setDisabled(disabled);
	}

	beforeIndex() {
		this.muAppendContent(`<label mu-template="item" mu-widget="UiRadioListItem">
			<input type="radio" mu-id="input">
			<!-- <img mu-id="icon" /> -->
			<span mu-id="title"></span>
		</label>`);
		this.htmlName = MuUIDs.next("name");
		this.muRegisterEvent('change');
	}

	public items: Record<string, UiRadioListItem> = {};

	public bindItems(items: RadioListItem[]|Record<string, string | RadioListItem>)
	{
		this.container.innerHTML = "";

		if (Array.isArray(items)) {
			for(const item of items)
				this.replaceItem(item);
		} else {
			for(const k in items) {
				let item = items[k];
				this.replaceItem((typeof item === "string")
					? {
						id: k,
						title: item,
					}
					: item
				);
			}
		}
	}

	public replaceItem(item: RadioListItem|(Partial<RadioListItem>&{id:RadioListItemId})) {
		if (!this.items[item.id]) {
			// @ts-ignore
			this.items[item.id] = this.muWidgetFromTemplate('item', this.container, item) as UiRadioListItem;
			if (this._value == item.id) this.value = this._value;
		} else {
			Object.assign(this.items[item.id], item);
			this.items[item.id].afterIndex();
		}
	}

	onChanged() {
		let v = null;
		this.selectedItem = null;
		for(const k in this.items) {
			if (this.items[k].getChecked()) {
				v = k;
				this.selectedItem = this.items[k];
			}
		}
		this._value = v;
		this.muDispatchEvent('change', this.value);
	}

	public get value() {
		return this._value;

		/* for(const k in this.items) {
			if (this.items[k].getChecked()) return k;
		}
		return null; */
	}

	public set value(v: RadioListItemId|null) {
		this._value = v;
		for(const k in this.items) {
			this.items[k].setChecked(k == v);
		}
	}
	private _value: RadioListItemId|null = null;

	muBindData(srcData: any) {
		this.value = srcData;
	}

	muFetchData() {
		return this.value;
	}
}

export class UiRadioListItem
		extends MuWidget<UiRadioList, {input: HTMLInputElement, title: HTMLElement}>
		implements RadioListItem {

	disabled: boolean = false;
	// @ts-ignore
	public id: RadioListItemId;
	public title: string|any;

	afterIndex() {
		this.ui.input.name = this.muParent.htmlName;
		this.ui.input.value = this.id;
		this.ui.input.disabled = this.disabled;
		// if (typeof this.title === "string")
		this.ui.title.innerText = this.title;
	}

	input_change() {
		this.muParent.onChanged();
	}

	setChecked(checked: boolean): void {
		this.ui.input.checked = checked;
	}

	getChecked(): boolean {
		return this.ui.input.checked;
	}

	setDisabled(disabled: boolean) {
		this.ui.input.disabled = disabled;
	}
}

export type RadioListItemId = string;

export type RadioListItem = {
	id: RadioListItemId;
	title: string;
	disabled?: boolean;
	// iconImage: string;
}